/* eslint-disable */
import * as React from 'react';
import Button from '@mui/material/Button';
import { IconButton, Snackbar } from '@mui/material';

type NotifProps = {
  setOpen: any;
  open: boolean;
  message: string;
};

export const Notif = (props: NotifProps) => {
  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    props.setOpen(false);
  };
  const action = (
    <React.Fragment>
      <Button style={{ color: 'white' }} size='small' onClick={handleClose}>
        Close
      </Button>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={handleClose}
      ></IconButton>
    </React.Fragment>
  );
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={props.open}
      autoHideDuration={3000}
      onClose={handleClose}
      message={props.message}
      action={action}
    />
  );
};
